<template>
    <div class="content work_wrapper">
        <v-row class="search_box">
            <v-col>
              <searchBar></searchBar>
            </v-col>
        </v-row>
        <router-view></router-view>
    </div>
</template>
<script>
import searchBar from "@/components/widgets/searchBar.vue";
export default {
    data() {
        return {

        }
    },
    components: {
        searchBar
    },
}
</script>